export const TOWN_DEFAULT_TIME_ZONE = "Asia/Ho_Chi_Minh";

/** Ho Chi Minh City; sunrise and sunset come from this point. */
export const TOWN_DEFAULT_OFFICE_LOCATION = { latitude: 10.8231, longitude: 106.6297 } as const;

export type TownOfficeTimeSettings = Readonly<{ timeZone: string; latitude: number; longitude: number }>;

export const TOWN_DEFAULT_OFFICE_TIME: TownOfficeTimeSettings = {
  timeZone: TOWN_DEFAULT_TIME_ZONE,
  ...TOWN_DEFAULT_OFFICE_LOCATION,
};

/** True for an IANA zone the runtime's Intl knows. */
export function isTownTimeZone(value: string): boolean {
  if (value.length === 0 || value.length > 64) return false;
  try {
    new Intl.DateTimeFormat("en-US", { timeZone: value });
    return true;
  } catch {
    return false;
  }
}
